import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import LogoutButton from './LogoutButton';
import AdminLink from './AdminLink';
import './Header.css';

function Header() {

    const { isAuthenticated, isLoading, user } = useAuth0();

    return (
        <header className="header">
            <nav>
                <ul className="nav-links">
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                     {/* Show these only when authenticated (optional) */}
                     {isAuthenticated && (
                        <>
                        <li><Link to="/manage-organizations">Manage Organizations</Link></li>
                        <AdminLink />
                        </>
                    )}
                    <li>
                        <Link to="/contact">Contact</Link>
                    </li>

                    {/* Right side: auth status */}
                    <li style={{ marginLeft: 'auto' }}>
                        {isLoading ? (
                        <span>Checking session…</span>
                        ) : isAuthenticated ? (
                        <div className="user-profile">
                            {user?.name && <span>Hi, {user.name}</span>}
                            <LogoutButton />
                        </div>
                        ) : (
                        null
                        )}
                    </li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;